import { AiAnswerBlock } from '@app/src/pages/Questionnaire/Accessor/Report/AiScreening/AiAnswerBlock'
import { CitationsForScrapedAnswer } from '@app/src/pages/Questionnaire/Accessor/Report/CitationsForScrapedAnswer'
import type { Provider } from '@app/src/types/organizations'
import type { ResponseItem } from '@app/src/types/resourceExplorer'
import { Box, Stack, Typography } from '@mui/material'
import React from 'react'
import { useIntl } from 'react-intl'
import { getSelectedOptionsCount } from './assessmentAnswersLogic'

interface AssessmentAnswerValueProps {
  item: ResponseItem
  provider: Provider | undefined
  showSelectedCount: boolean
  children: React.ReactNode
}

const AssessmentAnswerValue: React.FC<AssessmentAnswerValueProps> = ({
  item,
  provider,
  showSelectedCount,
  children,
}) => {
  const { formatMessage } = useIntl()
  const selectedCount = showSelectedCount ? getSelectedOptionsCount(item) : undefined
  const selectedCountText = selectedCount && (
    <Typography variant="body2" color="text.secondary">
      {formatMessage(
        { id: 'assessments.answersSelected' },
        { selectedCount: selectedCount.selected, totalAvailableCount: selectedCount.total },
      )}
    </Typography>
  )

  if (item.isScraped) {
    return (
      <Box border={1} borderColor="grey.300" borderRadius={1.5} overflow="hidden">
        <AiAnswerBlock>
          <Stack spacing={1.5}>
            {children}
            {selectedCountText}
          </Stack>
        </AiAnswerBlock>
        {item.isAnswered && item.scrapedAnswer && (
          <CitationsForScrapedAnswer
            scrapedAnswer={item.scrapedAnswer}
            provider={provider}
            questionType={item.requestItem.questionType?.name ?? ''}
          />
        )}
      </Box>
    )
  }

  return (
    <Stack spacing={1.5} px={2} py={1.5} borderRadius={1} bgcolor="grey.50">
      <Box flex={1} minWidth={0}>
        {children}
      </Box>
      {selectedCountText}
    </Stack>
  )
}

export default AssessmentAnswerValue
